import React, { useState } from 'react';
import * as Styles from './SiteBuilderAgentSuccess.styles';
import { SiteBuilderAgentSuccessProps } from './SiteBuilderAgentSuccess.types';
import {
  Button, IconDashboard, IconRobot, IconLoading,
} from 'gatorcomponents';
import circlesImage from '@/media/onboarding/aiBuilder/circles-to-background.png';
import starImage from '@/media/onboarding/aiBuilder/star-to-background.png';
import aiChatImage from '@/media/onboarding/aiBuilder/ai-chat.png';
import { useResize } from '@/hooks/useResize';

const SiteBuilderAgentSuccess = ({
  locales,
  handleRequestBuilderSso,
  loading,
  onEditAgent,
  onAgentSwitch,
}) => {
  const [isAgentActive, setIsAgentActive] = useState(true);

  const windowRect = useResize();
  const { width } = windowRect;
  const isMobile = width < 960;

  return (
    <Styles.Wrapper>
      <Styles.WaveTop>
        <Styles.CirclesImage src={circlesImage} alt="loading-circles" />
        <Styles.StarImage src={starImage} alt="loading-star" />
      </Styles.WaveTop>

      <Styles.InnerContainer>
        <Styles.Title>{locales.title}</Styles.Title>

        <Styles.Content>
          <Styles.CardSite>
            <Styles.Card>
              <Styles.CardHeader>
                <Styles.CardIcon>
                  <IconDashboard color="primaryBlue" size={isMobile ? 'sm' : 'md'} />
                </Styles.CardIcon>
                <Styles.CardTitle>{locales.siteBox.title}</Styles.CardTitle>
              </Styles.CardHeader>

              <Styles.CardText>{locales.siteBox.description}</Styles.CardText>

              <Styles.CardButtonSite>
                <Button
                  label={loading ? <IconLoading /> : locales.siteBox.button}
                  onClick={handleRequestBuilderSso}
                  variant="primary"
                  size="large"
                  width={isMobile ? 'full' : 'fit-content'}
                  version="v2"
                />
              </Styles.CardButtonSite>
            </Styles.Card>
          </Styles.CardSite>

          <Styles.CardAgent>
            <Styles.Card>
              <Styles.CardRow>
                <Styles.CardColumn>
                  <Styles.CardHeader>
                    <Styles.CardIcon>
                      <IconRobot color="primaryBlue" size={isMobile ? 'sm' : 'md'} />
                    </Styles.CardIcon>
                    <Styles.CardTitle>{locales.agentBox.title}</Styles.CardTitle>
                  </Styles.CardHeader>

                  <Styles.CardText>{locales.agentBox.description}</Styles.CardText>
                  <Styles.TextPolicy>{locales.agentBox.agentPolicy}</Styles.TextPolicy>

                  <Styles.CardButtonAgent>
                    <Styles.WrapperSwitch>
                      <Styles.SwitchWrapper>
                        <Styles.Switch
                          onClick={() => {
                            setIsAgentActive(!isAgentActive);
                            onAgentSwitch(!isAgentActive);
                          }}
                          active={isAgentActive}
                        >
                          <Styles.SwitchDot active={isAgentActive} />
                        </Styles.Switch>
                      </Styles.SwitchWrapper>
                      <Styles.TextSwitch>{locales.agentBox.agentActive}</Styles.TextSwitch>
                    </Styles.WrapperSwitch>

                    <Button
                      label={locales.agentBox.button}
                      onClick={onEditAgent}
                      variant="primary"
                      size="large"
                      width={isMobile ? 'full' : 'fit-content'}
                      version="v2"
                    />
                  </Styles.CardButtonAgent>
                </Styles.CardColumn>

                <Styles.CardColumnImage>
                  <Styles.AiChatImage src={aiChatImage} alt="ai-chat" />
                </Styles.CardColumnImage>
              </Styles.CardRow>
            </Styles.Card>
          </Styles.CardAgent>
        </Styles.Content>
      </Styles.InnerContainer>
    </Styles.Wrapper>
  );
};

SiteBuilderAgentSuccess.propTypes = SiteBuilderAgentSuccessProps;

export default SiteBuilderAgentSuccess;
